import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import PricesLight from '../../components/Prices/PricesLight';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const Honoraires = () => {
	return (
		<>
			<Navbar />
			<PageTitle pageTitle={'Honoraires'} pagesub={'Honoraires'} />
			<PricesLight />
			<Footer />
			<Scrollbar />
		</>
	);
};
export default Honoraires;
